"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _commonOptionCard = require("@mmc/common-option-card");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _configuratorModelSelector = _interopRequireDefault(require("../styles/configurator-model-selector.css"));
var _modelCardDetails = _interopRequireDefault(require("./model-card-details"));
var _configuratorModelSelector2 = require("./configurator-model-selector.props/configurator-model-selector.propTypes");
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var ModelOptions = function ModelOptions(_ref) {
  var models = _ref.models,
    theme = _ref.theme,
    market = _ref.market,
    updateSelectedCard = _ref.updateSelectedCard,
    selectedCard = _ref.selectedCard,
    msrpLabel = _ref.msrpLabel,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    isTrimLineInsteadOfModelCode = _ref.isTrimLineInsteadOfModelCode;
  var isUS = market === 'us';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, models && models.map(function (model, i) {
    var optionCardLabelYear = isUS ? handleNestedProp(model, 'model.year') + " " : '';
    var value = isTrimLineInsteadOfModelCode ? handleNestedProp(model, 'model.trimLine') : handleNestedProp(model, 'model.code');
    var label = isTrimLineInsteadOfModelCode ? handleNestedProp(model, 'model.trimLine') : "" + optionCardLabelYear + handleNestedProp(model, 'model.name');
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "" + (i + model),
      className: theme['col-xs-12'] + " " + theme['col-md-6'] + " " + _configuratorModelSelector["default"].optionCardContainer + " " + theme.marginBottom40
    }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
      theme: theme,
      onChange: updateSelectedCard,
      name: "model-selector",
      id: handleNestedProp(model, 'model.id'),
      value: value,
      label: label,
      fullTap: true,
      isSelected: selectedCard === value,
      type: "radio"
    }, /*#__PURE__*/_react["default"].createElement(_modelCardDetails["default"], {
      engineSize: handleNestedProp(model, 'model.engineSize'),
      fuelType: handleNestedProp(model, 'model.fuelType'),
      drivetrain: handleNestedProp(model, 'model.drivetrain'),
      transmissionType: handleNestedProp(model, 'model.transmissionType'),
      prefix: isUS && msrpLabel ? msrpLabel : false,
      engineType: handleNestedProp(model, 'model.engineType'),
      displayValue: !isUS && msrpLabel ? handleNestedProp(model, 'model.price.displayValue') : '',
      zeroMessage: handleNestedProp(model, 'model.price.zeroMessage'),
      price: handleNestedProp(model, 'model.price.baseValue'),
      technicalDetails: model.technicalDetails,
      theme: theme,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      descriptionList: handleNestedProp(model, 'model.descriptionList')
    })));
  }));
};
var _default = ModelOptions;
exports["default"] = _default;